import type { FurnitureObject, Project, Vec3 } from '../types';

/** Axis-aligned footprint of the furniture, including its Y-axis rotation. */
export function furnitureFootprint(item: FurnitureObject) {
  const angle = item.rotation[1];
  const halfX = (Math.abs(Math.cos(angle)) * item.width + Math.abs(Math.sin(angle)) * item.depth) / 2;
  const halfZ = (Math.abs(Math.sin(angle)) * item.width + Math.abs(Math.cos(angle)) * item.depth) / 2;
  return {
    left: item.position[0] - halfX,
    right: item.position[0] + halfX,
    back: item.position[2] - halfZ,
    front: item.position[2] + halfZ,
    halfX,
    halfZ,
  };
}

/** Display the near corner as the object's X/Z location, relative to the movable origin. */
export function furnitureCoordinates(item: FurnitureObject, origin: Vec3): Vec3 {
  const bounds = furnitureFootprint(item);
  const display = (value: number) => Math.round(value * 1000) / 1000;
  return [display(bounds.left - origin[0]), display(item.position[1] - origin[1]), display(bounds.back - origin[2])];
}

export function positionAtCoordinates(item: FurnitureObject, origin: Vec3, coordinates: Vec3): Vec3 {
  const { halfX, halfZ } = furnitureFootprint(item);
  return [origin[0] + coordinates[0] + halfX, origin[1] + coordinates[1], origin[2] + coordinates[2] + halfZ];
}

/** Insert at the user origin. Internal mesh coordinates remain center based. */
export function insertionPosition(project: Project, item: FurnitureObject): Vec3 {
  return positionAtCoordinates(item, project.origin, [0, 0, 0]);
}
